module.exports = __webpack_public_path__ + "static/media/checkbox-checked.28ee2cfd.svg";